<template>
  <div class="video-box">
    <div id="dplayer" class="dplayer" ref="dplayer"></div>
  </div>
</template>

<script>
export default {
  name: 'VideoPlayer',
  props:{
    url: String
  },
  data(){
    return {
      dPlayer: null,
      initSeq: 0
    }
  },
  watch: {
    url(val, oldVal) {
      if (!val || val === oldVal) return;
      this.teardown();
      this.$nextTick(() => {
        this.init();
      });
    }
  },
  mounted() {
    this.init()
  },
  beforeDestroy() {
    this.teardown();
  },
  methods: {
    resolveHls() {
      const mod = require('hls.js');
      return (mod && mod.default) ? mod.default : mod;
    },
    setupHls(video, player, source) {
      try {
        const Hls = this.resolveHls();
        if (!Hls || typeof Hls.isSupported !== 'function' || !Hls.isSupported()) {
          player.notice('Error: Hls is not supported.');
          return;
        }
        if (!source) {
          player.notice('Error: Empty video url.');
          return;
        }
        if (video.getAttribute('src')) {
          video.removeAttribute('src');
        }
        // 官方推荐顺序：先 loadSource 再 attachMedia，避免漏掉同步 MEDIA_ATTACHED
        const hls = new Hls();
        player.plugins.hls = hls;
        hls.loadSource(source);
        hls.attachMedia(video);
        if (Hls.Events && Hls.Events.MANIFEST_PARSED) {
          hls.on(Hls.Events.MANIFEST_PARSED, () => {
            const playPromise = video.play();
            if (playPromise && typeof playPromise.catch === 'function') {
              playPromise.catch(() => {});
            }
          });
        }
        if (Hls.Events && Hls.Events.ERROR) {
          hls.on(Hls.Events.ERROR, (event, data) => {
            console.error('[VideoPlayer][HLS]', data);
            if (data && data.fatal) {
              player.notice('Video load failed');
            }
          });
        }
        player.events.on('destroy', () => {
          try {
            hls.destroy();
          } catch (e) { /* ignore */ }
          delete player.plugins.hls;
        });
      } catch (err) {
        console.error('[VideoPlayer] setupHls failed:', err);
        try {
          player.notice('Video load failed');
        } catch (e) { /* ignore */ }
      }
    },
    destroyPlayer() {
      if (this.dPlayer) {
        try {
          this.dPlayer.destroy();
        } catch (e) {
          console.warn('VideoPlayer destroy failed:', e);
        }
        this.dPlayer = null;
      }
    },
    teardown() {
      this.initSeq += 1;
      this.destroyPlayer();
    },
    async init(){
      if (!this.url) {
        console.warn('VideoPlayer: video url is empty, skip init');
        return;
      }
      if (!this.$refs.dplayer) {
        return;
      }
      const seq = ++this.initSeq;
      const playUrl = this.url;
      try {
        const dp = await import('dplayer');
        if (seq !== this.initSeq || !this.$refs.dplayer) {
          return;
        }
        this.destroyPlayer();
        const _DPlayer = dp.default || dp;
        this.dPlayer = new _DPlayer({
          container: this.$refs.dplayer,
          autoplay: false,
          video: {
            url: '',
            type: 'customHls',
            customType: {
              customHls: (video, player) => {
                this.setupHls(video, player, playUrl);
              }
            }
          },
        });
      } catch (err) {
        console.error('[VideoPlayer] init failed:', err);
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.video-box {
  height: 100%;
  width: 100%;
  .dplayer {
    height: 100%;
    width: 100%;
    border-radius: 4px;
  }
}
</style>
